import { Component, Input, OnInit } from '@angular/core';
import { ObjectUtils } from '@cv-invision/core';
import { LayoutRenderLayoutItem } from '../../../models/cv-layout-render.model';
import { FieldsSectionOptions } from '../../models/component-options/fields-section.options';

@Component({
	selector: 'cv-invision-ux-dynamic-fields-section',
	templateUrl: './dynamic-fields-section.component.html'
})
export class DynamicFieldsSectionComponent implements OnInit {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();

	title = null;
	options = new FieldsSectionOptions();
	rows = [];

	ngOnInit(): void {
		Object.assign(this.options, this.layoutNode.options);
		this.title = null;
		if ('title' in this.layoutNode) {
			this.title = this.layoutNode.title;
		}

		this.rows = [];
		this.rows = ObjectUtils.recursiveDeepCopy(this.layoutNode.items);

		if (this.options.appendPath) {
			this.rows = this.recursive(this.rows);
		}
	}

	recursive(items: any): any {
		if (!items) {
			return items;
		}

		if ('[object Array]' === Object.prototype.toString.apply(items)) {
			for (let index = 0; index < items.length; index += 1) {
				items[index] = this.recursive(items[index]);
			}
		}

		if (!Array.isArray(items) && typeof items === 'object') {
			for (const key in items) {
				if (items[key] && typeof items[key] === 'object') {
					items[key] = this.recursive(items[key]);
				}

				if (key === 'path') {
					items[key] = `${this.data._DocumentPath}.${items[key]}`;
				}
			}
		}

		return items;
	}
}
